import * as React from "react";
import UploadFiles from "./UploadFiles";
import { getFormsForRole } from "./teamMemberForms";

const TeamMemberUploadDocInfo = ({isDisabled, data, handleChangeInput, handleChangeFile, viewMode, deleted, onUploadingChange}) => {
    // Safety check - if data is not loaded yet, default to 'e' (Summit Employee)
    const forms = getFormsForRole(data && data.IS_AGENT ? data.IS_AGENT : 'e');

    return (
        <div className="Team-member-info">
            <div className="Team-member-info_column">
                <UploadFiles
                    classNames="Team-member-info_column_item"
                    data={data}
                    viewMode={viewMode}
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    initialFilesAmount={5}
                    maxFilesAmount={forms.length}
                    items={forms}
                    disabled={isDisabled}
                    handleChangeInput={handleChangeInput}
                    onUploadingChange={onUploadingChange}
                />

            </div>
        </div>
    );
};

export default TeamMemberUploadDocInfo;
